/**
 * 主界面中心组件
 * 创建时间：2017-02-22
 *   创建人：zhanlz
 */
<template>	
		<div style="width:100%;height:100%;position:relative;">
			系统设置
			
		</div>	
</template>

<script>
	export default {
		name: 'PageSetting',
		components: {
		
			
		},
		data() {
			return {

			};
		}
	};
</script>


// WEBPACK FOOTER //
// PageSetting.vue?e677581e